<template lang="pug">
    div(class="_btna")
        // @slot Pass in a div containing multiple buttons here
        slot
</template>

<script>
    /**
     * A container that causes enclosed buttons to appear in a row without a
     * separating margin.
     */
    export default {
        name: 'ib-button-array'
    }
</script>

<style lang="less">
    @import "../../less/globals.less";

    ._btna {
        display: inline-block;
        white-space: nowrap;
        line-height: inherit;
        min-width: 0;
        margin: 2px 4px;
        padding: 0 !important;
        border: 0;
        overflow: visible;
        ._btn {
            margin: 0;
            & {
                border-radius: 0;
            }
            &:first-child {
                border-radius: 3px 0 0 3px;
            }
            &:last-child {
                border-radius: 0 3px 3px 0;
            }
            + ._btn {
                border-left-style: hidden;
                &::after {
                    left: -1px;
                }
            }
        }
        &:@{btn-focus},
        &:@{btn-hover} {
            -webkit-filter: none;
                    filter: none;
        }
    }

    [dir=rtl] ._btna {
        ._btn {
            &:first-child {
                border-radius: 0 3px 3px 0;
            }
            &:last-child {
                border-radius: 3px 0 0 3px;
            }
            + ._btn {
                border-left-style: solid;
                border-right-style: hidden;
            }
        }
    }
</style>

<docs>
    Basic Example:
    ```jsx
        new Vue({
            data() {
                return {
                    selected: '1'
                };
            },
            template: `
                <ib-button-array>
                    <ib-button :class="selected == '1' && 'accent'" @click="selected = '1'">State 1</ib-button><ib-button :class="selected == '2' && 'accent'" @click="selected = '2'">State 2</ib-button><ib-button :class="selected == '3' && 'accent'" @click="selected = '3'">State 3</ib-button>
                </ib-button-array>
            `
        });
    ```
</docs>
